import styled from 'styled-components';

import { Tooltip } from '../../cdl/Tooltip/Tooltip';
import { translate } from '../helpers/translate.helper';
import { useRole } from '../hooks/useRole';
import { useSidebar } from '../hooks/useSidebar';
import { IconSettings } from '../icons/cdl/Settings';
import { Box } from '../ui/Box';

import { GlobalSearch } from './GlobalSearch';
import { TopBarButton } from './TopBarButton';
import { IconCompass } from '../icons/cdl/Compass';
import { NavigationLink } from '../Link/NavigationLink';
import { theme } from '../ui/theme';

const TopbarNavigationItem = styled(NavigationLink)`
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 100%;
    color: ${theme.colors.foreground.muted};

    &:hover,
    &:focus {
        color: ${theme.colors.foreground.default};
        text-decoration: none;
        background-color: ${theme.colors.background.inset};
    }

    &.active {
        color: ${theme.colors.accent.foreground};
        background-color: ${theme.colors.background.subtle};

        &:hover {
            background-color: ${theme.colors.accent.background};
        }
    }
`;

export const Topbar = () => {
    const role = useRole();
    const { isFixed } = useSidebar();

    return (
        <Box
            display="flex"
            paddingLeft={24}
            paddingRight={24}
            backgroundColor="white"
            height="60px"
            alignItems="center"
            position="fixed"
            top="0"
            left={isFixed ? '220px' : '0px'}
            right="0"
            // this was the topbar's previous z-index, using the same index for
            // compatibility:
            zIndex="topbar"
            style={{
                transition: 'left 0.15s ease-out',
            }}
        >
            <Box display="flex" width="100%" alignItems="center" justifyContent="space-between" gap={16}>
                <Box width="420px">
                    <GlobalSearch />
                </Box>

                <Box display="flex" alignItems="center" gap={8}>
                    <TopBarButton onClick={() => Productlane?.toggle()}>
                        <IconCompass />
                    </TopBarButton>

                    <Tooltip label={translate('navigation.tooltips.settings')}>
                        <span>
                            <TopbarNavigationItem
                                to={role.hasAnyAdminRights() ? '/settings' : '/me'}
                                params={!role.hasAnyAdminRights() ? { id: role.user.id } : undefined}
                            >
                                <IconSettings />
                            </TopbarNavigationItem>
                        </span>
                    </Tooltip>
                </Box>
            </Box>
        </Box>
    );
};
